import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';

// CLICK_SHORT_BANNER 로깅에 사용하는 배너 이름
const AI_CONTENT_DRAFT_BANNER_NAME = 'AI로 콘텐츠 초안 만들기';

/**
 * 'AI 콘텐츠 초안 만들기' 배너 클릭 로깅.
 * SCREEN/EVENT_TYPE 은 useLogGoodsAnalyticsEvent 에서 자동 주입된다.
 */
export const useLogClickAiContentDraftBanner = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_SHORT_BANNER',
      analytics: {
        BANNER_NAME: AI_CONTENT_DRAFT_BANNER_NAME,
      },
    });
  }, [logGoodsAnalytics]);
};
